import { create } from "zustand";
import { subscribeWithSelector } from "zustand/middleware";

type StateStoreRoomSession = {
    roomId: string | null;
};

type StoreRoomSessionActions = {
    init: (roomId: string) => void;
    reset: () => void;
};

const useStoreRoomSession = create<StateStoreRoomSession & StoreRoomSessionActions>()(
    subscribeWithSelector((set) => ({
        roomId: null,

        init: (roomId: string) => {
            set({ roomId });
        },

        reset: () => {
            set({ roomId: null });
        },
    }))
);

export default useStoreRoomSession;
